// extracted by mini-css-extract-plugin
export default {"Container":"UiDrawerTabs_Container__kXvN4","Indicator":"UiDrawerTabs_Indicator__e+8ud","Tab":"UiDrawerTabs_Tab__0rJY1","Tabs":"UiDrawerTabs_Tabs__3voMq"};